import {metadaApi} from '@dms/api/base';

import {
  PostAlternativeSparePartsByCatalogueNumberRequest,
  PostAlternativeSparePartsByCatalogueNumberRequestSchema,
  PostAlternativeSparePartsByCatalogueNumberResponse,
  PostAlternativeSparePartsByCatalogueNumberResponseSchema,
} from './types';

export const metadaWarehouseAlternativeSparePartsApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getAlternativeSparePartsByCatalogueNumber: build.query<
      PostAlternativeSparePartsByCatalogueNumberResponse,
      PostAlternativeSparePartsByCatalogueNumberRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/alternative-spare-parts/search`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      extraOptions: {
        requestSchema: PostAlternativeSparePartsByCatalogueNumberRequestSchema,
        responseSchema: PostAlternativeSparePartsByCatalogueNumberResponseSchema,
      },
    }),
  }),
});

export const {useGetAlternativeSparePartsByCatalogueNumberQuery} =
  metadaWarehouseAlternativeSparePartsApi;
